module.exports = !require('../internals/fails')(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/freezing.js
// module id = 129
// module chunks = 0